import clsx from 'clsx'
import React from 'react'

import {PropsWithClasses} from '../../theme/UNSTABLE_makeStyles'
import {Typographyv2 as Typography, TypographyVariants} from '../../v2/typography'
import {ClassKey, sizeClasses, useClasses} from './ChipStatus.classes'
import {ChipSize, ColorClassName, StatusColor} from './types'

type Props = PropsWithClasses<ClassKey> & {
  color?: StatusColor
  size?: ChipSize
  variant?: TypographyVariants
  label: React.ReactNode
}

const ChipStatus: React.FC<Props> = ({
  color = 'unknown',
  size = 'm',
  variant = 'caption2',
  label,
  classes: classesProp,
}) => {
  const classes = useClasses(classesProp)

  return (
    <Typography
      className={clsx(classes.root, color && classes[`color_${color}` as ColorClassName], size && sizeClasses[size])}
      Component="div"
      thickness="medium"
      variant={variant}
    >
      {label}
    </Typography>
  )
}

export default ChipStatus
